'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from '../Tag';
import * as styles from './ToggleGroup.styles';
export const ToggleGroup = ({ children, value, onValueChange, ...props }) => (_jsx("div", { className: "flex items-center justify-start", children: React.Children.map(children, (child, index) => {
        if (!React.isValidElement(child))
            return child;
        const position = index === 0 ? 'first' : index === React.Children.count(children) - 1 ? 'last' : 'middle';
        const isSelected = child.props?.['value'] === value;
        return React.cloneElement(child, {
            ...props,
            onValueChange,
            position,
            isSelected,
            ...child.props,
        });
    }) }));
export const ToggleGroupItem = ({ value, position, isSelected, children, onValueChange, }) => {
    return (_jsx(Tag, { selected: !!isSelected, onClick: value && onValueChange ? () => onValueChange(value) : undefined, className: styles.toggleItem({
            position,
        }), size: "xs", children: children }));
};
